module.exports = __webpack_public_path__ + "static/src/content/images/processed/800/thurston_cover.7507e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/800/thurston_cover.jpg
// module id = 9XWi
// module chunks = 1